// Format / normalize pre-pass (the "⌘ Format" button). Prettifies minified
// JSON/YAML (and sorts keys) so the literal/Raw view and copy-out are clean —
// the semantic engine normalizes regardless, so this is purely for humans.
import { load as loadYaml, dump as dumpYaml } from 'js-yaml';

export function formatContent(text, format) {
  const t = text.trim();
  if (!t) return text;
  try {
    if (format === 'json') return JSON.stringify(sortKeys(parseLoose(t)), null, 2);
    if (format === 'yaml') return dumpYaml(loadYaml(t), { sortKeys: true }).trimEnd();
  } catch {
    /* not parseable — leave as-is */
  }
  return text;
}

function parseLoose(t) {
  try {
    return JSON.parse(t);
  } catch {
    return loadYaml(t); // JSON tab may hold YAML
  }
}

function sortKeys(v, seen = new WeakSet()) {
  if (Array.isArray(v)) {
    if (seen.has(v)) return v; // cyclic (YAML alias) — stop recursing
    seen.add(v);
    return v.map((x) => sortKeys(x, seen));
  }
  if (v && typeof v === 'object') {
    if (seen.has(v)) return v;
    seen.add(v);
    const out = Object.create(null);
    for (const k of Object.keys(v).sort()) out[k] = sortKeys(v[k], seen);
    return out;
  }
  return v;
}
